import { SubmissionMarketRequestClient } from 'clients';
import { MarketViaApiBody } from 'clients/capitola/submission-market-request';
import { QueryKeys } from 'enums';
import { useClient } from 'hooks/useClient';
import { SubmissionMarketRequest } from 'types';
import { MutateProps, UseQueryBaseSearchOptions } from './query/types';
import { useMutate } from './query/useMutate';
import { useImperativeQuery, useQuerySearch } from './query/useQuery';

export function useSearchSubmissionMarketRequest(props?: UseQueryBaseSearchOptions<SubmissionMarketRequest>) {
  const { filter, queryOptions } = props || {};
  return useQuerySearch({
    queryKey: QueryKeys.SubmissionMarketRequest,
    clientClass: SubmissionMarketRequestClient,
    filter,
    queryOptions: {
      // Default submssion search query options should be passed here for example:   cacheTime: 10 * 60 * 60 * 1000,
      ...queryOptions,
    },
  });
}

export function useMutateSubmissionMarketRequest(options?: MutateProps) {
  const {
    create: createSubmissionMarketRequest,
    update: updateSubmissionMarketRequest,
    destroy: destroySubmissionMarketRequest,
  } = useMutate<
    SubmissionMarketRequest,
    SubmissionMarketRequest,
    Partial<SubmissionMarketRequest>,
    SubmissionMarketRequestClient
  >({
    queryKey: QueryKeys.SubmissionMarketRequest,
    clientClass: SubmissionMarketRequestClient,
    cancelInvalidation: options?.cancelInvalidation,
    createOptions: { throwOnError: true },
    updateOptions: { throwOnError: true },
  });

  return { createSubmissionMarketRequest, updateSubmissionMarketRequest, destroySubmissionMarketRequest };
}

export function useSubmitMarketRequestsViaApi() {
  const submissionMarketRequestClient = useClient(SubmissionMarketRequestClient);

  return useImperativeQuery<{} | null, MarketViaApiBody>({
    queryFn: (data) => submissionMarketRequestClient.marketViaApi(data),
    queryKey: [QueryKeys.SubmissionMarketRequest, 'market-via-api'],
  });
}
